const initialState: Array<object> = [];



/**
 * evaluateListDataReducer: Reducer to manage the training list data state.
 *
 * @param {Array<object>} state - The current state of the training list data.
 * @param {any} action - The action dispatched to the reducer.
 * @returns {Array<object>} The updated state based on the action type.
 */

const evaluateListDataReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case "SET_EVALUATE_LIST_DATA":
      return action?.payload || [];
    default:
      return state;
  }
};

export default evaluateListDataReducer;
